import { Command } from '../Command';
import { UpdateRowHeightsOperation } from '../../Operations/TableOperations';
import { ErrorElementNotEditable } from '../../Errors';

export class UpdateRowHeigthsCommand extends Command {
  tableId: string;
  rowHeights: number[];

  constructor(context: Editor.Edition.Context, tableId: string, rowHeights: number[]) {
    super(context);

    this.tableId = tableId;
    this.rowHeights = rowHeights;
  }

  async handleExec(): Promise<void> {
    if (!this.askUserAboutThis()) {
      return;
    }

    this.buildActionContext();

    if (!this.context.DataManager || !this.context.DataManager.selection || !this.actionContext) {
      throw new Error('Invalid context');
    }
    if (
      !(
        this.actionContext.baseModel.id === this.tableId ||
        this.actionContext.baseModel.getChildInfoById(this.tableId)
      )
    ) {
      throw new Error('Invalid data');
    }

    // check if element is editable
    if (!this.context.DataManager.nodes.isNodeEditable(this.actionContext.baseModel.id)) {
      throw new ErrorElementNotEditable();
    }

    const operation = this.getOperation(this.actionContext.baseModel);
    operation.apply();

    // create patch
    this.createPatch();
  }

  private getOperation(baseModel: Editor.Data.Node.Model) {
    return new UpdateRowHeightsOperation(baseModel, this.tableId, this.rowHeights);
  }
}
